import { intersectionObserver } from "./intersection-observer";

export function countUp(obj: { trigger: string; }) {
  class CountUp {
    triggers: NodeListOf<Element>;

    constructor() {
      this.triggers = document.querySelectorAll(`.${obj.trigger}`)
      this.init();
    }

    init() {
      this.intersectionCoutUp();
    }

    countUp(trigger) {
      const target = trigger.getAttribute('data-count');
      const targetNum = Number(target);
      let count = 0;
      const duration = 2000;
      const startTime = performance.now();

      function update() {
        const now = performance.now();
        const elapsedTime = now - startTime;
        const progress = Math.min(elapsedTime / duration, 1);

        count = Math.floor(progress * target);

        if (!trigger.classList.contains('js-countup-flat')) {
          trigger.textContent = count.toLocaleString();

          if (progress < 1) {
            requestAnimationFrame(update);
          } else {
            trigger.textContent = targetNum.toLocaleString();
          }
        } else {
          trigger.textContent = count;

          if (progress < 1) {
            requestAnimationFrame(update);
          } else {
            trigger.textContent = targetNum;
          }
        }
      }

      requestAnimationFrame(update);
    }

    intersectionCoutUp() {
      intersectionObserver(
        {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        },
        {
          type: 'through',
          observationTarget: '.js-countup',
          changeTarget: '.js-countup',
          addClass: null,
          changeTargetAddClass: 'is-active',
          bodyAddClass: false,
          addFunc: (entry) => {
            this.countUp(entry.target);
          }
        }
      )
    }
  }

  new CountUp();
}

